export default __webpack_public_path__ + "static/media/banner5-resized.dd707e50.jpeg";